module.exports = __webpack_public_path__ + "img/sq4d_05.a13f3085.jpg";